import { Descriptions, Skeleton } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
export type DescriptionItem = {
  label: ReactNode;
  value: ReactNode;
  key?: string | number;
};
export interface DescriptionListProps {
  title?: ReactNode;
  items: DescriptionItem[];
  columns?: number;
  labelWidth?: number;
  contentAlign?: "left" | "right";
  layout?: "horizontal" | "vertical";
  verticalAlign?: "center" | "top";
  className?: string;
  compact?: boolean;
  isLoading?: boolean;
}
export const DescriptionList = ({
  title,
  items,
  columns = 1,
  labelWidth,
  contentAlign = "left",
  layout = "horizontal",
  verticalAlign = "center",
  className,
  compact = true,
  isLoading = false
}: DescriptionListProps) => {
  const baseClasses = ["[&_.ant-descriptions-header]:mb-2", "[&_.ant-descriptions-title]:text-sm", "[&_.ant-descriptions-title]:font-semibold", "[&_.ant-descriptions-item-label]:!flex", verticalAlign === "top" ? "" : "[&_.ant-descriptions-item-label]:!items-center", "[&_.ant-descriptions-item-content]:!flex", "[&_.ant-descriptions-item-content]:!items-center"];
  const compactClasses = compact ? "[&_.ant-descriptions-item]:!pb-1" : "";
  return <>
      <Descriptions title={title} colon={false} size="small" column={columns} layout={layout ?? "horizontal"} className={classNames(baseClasses, compactClasses, className)} styles={{
      label: {
        width: labelWidth,
        fontWeight: 400,
        letterSpacing: "-0.01em",
        alignItems: verticalAlign
      },
      content: {
        justifyContent: contentAlign === "right" ? "flex-end" : "flex-start",
        alignItems: verticalAlign,
        letterSpacing: "-0.01em"
      }
    }} items={items.map((it, idx) => ({
      key: it.key ?? idx,
      label: it.label,
      children: it.value
    }))} data-sentry-element="Descriptions" data-sentry-source-file="DescriptionList.tsx" />
      {isLoading && <div>
          <Skeleton loading={isLoading} active />
        </div>}
    </>;
};